var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveDimenzioni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210.906,
    height: 140,
    viewBox: "0 0 210.906 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3887",
    "data-name": "Tracciato 3887",
    d: "M2.875,46.307A43.778,43.778,0,1,0,46.652,2.875,43.606,43.606,0,0,0,2.875,46.307",
    transform: "translate(-2.875 -2.875)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3888",
    "data-name": "Tracciato 3888",
    d: "M12.983,51.75A41.722,41.722,0,1,0,54.7,10.289,41.592,41.592,0,0,0,12.983,51.75",
    transform: "translate(-12.983 -10.289)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1090",
    "data-name": "Rettangolo 1090",
    width: 88.897,
    height: 88.208,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3889",
    "data-name": "Tracciato 3889",
    d: "M55.832,85.673A31.594,31.594,0,1,0,87.426,54.229,31.519,31.519,0,0,0,55.832,85.673",
    transform: "translate(-55.832 -54.229)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3890",
    "data-name": "Tracciato 3890",
    d: "M323.943,197.584a6.464,6.464,0,0,0,.122,1.658,31.393,31.393,0,0,0,.371-3.467h0a5.016,5.016,0,0,0-.493,1.809",
    transform: "translate(-323.934 -195.775)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1094",
    "data-name": "Rettangolo 1094",
    width: 8.226,
    height: 9.284,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1095",
    "data-name": "Rettangolo 1095",
    width: 6.03,
    height: 10.141,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1096",
    "data-name": "Rettangolo 1096",
    width: 39.801,
    height: 42.825,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1097",
    "data-name": "Rettangolo 1097",
    width: 2.885,
    height: 2.764,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1098",
    "data-name": "Rettangolo 1098",
    width: 0.662,
    height: 0.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1099",
    "data-name": "Rettangolo 1099",
    width: 3.93,
    height: 3.624,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1100",
    "data-name": "Rettangolo 1100",
    width: 1.381,
    height: 1.214,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1101",
    "data-name": "Rettangolo 1101",
    width: 1.124,
    height: 1.714,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1102",
    "data-name": "Rettangolo 1102",
    width: 1.322,
    height: 2.358,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1103",
    "data-name": "Rettangolo 1103",
    width: 3.023,
    height: 1.772,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1104",
    "data-name": "Rettangolo 1104",
    width: 2.96,
    height: 1.281,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1105",
    "data-name": "Rettangolo 1105",
    width: 0.783,
    height: 1.533,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1106",
    "data-name": "Rettangolo 1106",
    width: 0.826,
    height: 0.999,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1107",
    "data-name": "Rettangolo 1107",
    width: 0.726,
    height: 1.004,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1108",
    "data-name": "Rettangolo 1108",
    width: 2.518,
    height: 2.351,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1112",
    "data-name": "Rettangolo 1112",
    width: 7.242,
    height: 8.951,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1113",
    "data-name": "Rettangolo 1113",
    width: 7.628,
    height: 8.847,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1114",
    "data-name": "Rettangolo 1114",
    width: 7.492,
    height: 8.852,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1123",
    "data-name": "Rettangolo 1123",
    width: 0.447,
    height: 2.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1131",
    "data-name": "Rettangolo 1131",
    width: 0.447,
    height: 2.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1133",
    "data-name": "Rettangolo 1133",
    width: 0.447,
    height: 3.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1135",
    "data-name": "Rettangolo 1135",
    width: 0.447,
    height: 11.348,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1137",
    "data-name": "Rettangolo 1137",
    width: 0.447,
    height: 2.847,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1143",
    "data-name": "Rettangolo 1143",
    width: 0.447,
    height: 2.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1145",
    "data-name": "Rettangolo 1145",
    width: 0.447,
    height: 3.226,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1147",
    "data-name": "Rettangolo 1147",
    width: 0.447,
    height: 3.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1149",
    "data-name": "Rettangolo 1149",
    width: 0.447,
    height: 3.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1151",
    "data-name": "Rettangolo 1151",
    width: 0.447,
    height: 11.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1152",
    "data-name": "Rettangolo 1152",
    width: 0.447,
    height: 6.618,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1154",
    "data-name": "Rettangolo 1154",
    width: 0.447,
    height: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1156",
    "data-name": "Rettangolo 1156",
    width: 0.447,
    height: 4.674,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1158",
    "data-name": "Rettangolo 1158",
    width: 31.22,
    height: 41.831,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1790",
    "data-name": "Raggruppa 1790",
    transform: "translate(-4817.094 -2722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1788",
    "data-name": "Raggruppa 1788",
    transform: "translate(4400.14 2182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1377",
    "data-name": "Raggruppa 1377",
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_762",
    "data-name": "Rettangolo 762",
    transform: "translate(417 499)",
    fill: "#fff",
    stroke: "#413333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 125,
    rx: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 124,
    rx: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2129",
    "data-name": "Tracciato 2129",
    d: "M4990.954,488.533H5062",
    transform: "translate(-4574 5)",
    fill: "none",
    stroke: "#413333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_25.5_mm",
    "data-name": "25.5 mm",
    transform: "translate(441 490)",
    fill: "#413333",
    fontSize: 6,
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.5 mm"))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1378",
    "data-name": "Raggruppa 1378",
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_763",
    "data-name": "Rettangolo 763",
    transform: "translate(510 499)",
    fill: "#fff",
    stroke: "#413333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 125,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 124,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2130",
    "data-name": "Tracciato 2130",
    d: "M4990.954,488.533h13",
    transform: "translate(-4480.954 5)",
    fill: "none",
    stroke: "#413333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4.5_mm",
    "data-name": "4.5 mm",
    transform: "translate(507 490)",
    fill: "#413333",
    fontSize: 6,
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4.5 mm")))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1789",
    "data-name": "Raggruppa 1789",
    transform: "translate(4738.104 2487.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1699",
    "data-name": "Raggruppa 1699",
    transform: "translate(201 260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1540",
    "data-name": "Raggruppa 1540",
    transform: "translate(0.672 0.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1539",
    "data-name": "Raggruppa 1539",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rettangolo_1087",
    "data-name": "Rettangolo 1087",
    width: 87.855,
    height: 87.154,
    transform: "translate(-0.204 -0.086)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1544",
    "data-name": "Raggruppa 1544",
    transform: "translate(3.034 2.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1543",
    "data-name": "Raggruppa 1543",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rettangolo_1089",
    "data-name": "Rettangolo 1089",
    width: 83.883,
    height: 83.182,
    transform: "translate(-0.23 -0.182)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1546",
    "data-name": "Raggruppa 1546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1545",
    "data-name": "Raggruppa 1545",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_249",
    "data-name": "Ellisse 249",
    cx: 41.721,
    cy: 41.461,
    rx: 41.721,
    ry: 41.461,
    transform: "translate(3.034 2.404)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.666
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1548",
    "data-name": "Raggruppa 1548",
    transform: "translate(13.046 12.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1547",
    "data-name": "Raggruppa 1547",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rettangolo_1091",
    "data-name": "Rettangolo 1091",
    width: 63.555,
    height: 63.088,
    transform: "translate(-0.194 -0.168)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1550",
    "data-name": "Raggruppa 1550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1549",
    "data-name": "Raggruppa 1549",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_250",
    "data-name": "Ellisse 250",
    cx: 31.594,
    cy: 31.444,
    rx: 31.594,
    ry: 31.444,
    transform: "translate(13.046 12.671)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.136
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1552",
    "data-name": "Raggruppa 1552",
    transform: "translate(250.227 305.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1551",
    "data-name": "Raggruppa 1551",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rettangolo_1093",
    "data-name": "Rettangolo 1093",
    width: 0.935,
    height: 3.739,
    transform: "translate(-0.218 -0.062)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAQCAYAAAAxtt7zAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAABKADAAQAAAABAAAAEAAAAABzxO16AAAAG0lEQVQYGWM8c+bMaQYGhv9ADAZMMAaMHlkCAHNABE4HxBjnAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1698",
    "data-name": "Raggruppa 1698",
    transform: "translate(201 260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1697",
    "data-name": "Raggruppa 1697",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1555",
    "data-name": "Raggruppa 1555",
    transform: "translate(75.69 43.125)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1554",
    "data-name": "Raggruppa 1554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1553",
    "data-name": "Raggruppa 1553",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3891",
    "data-name": "Tracciato 3891",
    d: "M328.787,184.565a4.734,4.734,0,0,0-4.844,4.429c-.15,3.069,1.609,4.822,3.576,4.854,2.169-.021,3.861-1.14,4.641-4.34-.141-.063.623-4.194-3.373-4.943Zm-.581.523a2.663,2.663,0,0,1,.468.027c2.518,1.16,2.129,2.137,2.107,4.229-.387,1.835-1.144,4.19-3.318,3.842,0,0-2.869-.122-2.237-4.413C325.8,186.472,326.749,185.131,328.206,185.088Z",
    transform: "translate(-323.934 -184.565)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3892",
    "data-name": "Tracciato 3892",
    d: "M328.787,184.565a4.734,4.734,0,0,0-4.844,4.429c-.15,3.069,1.609,4.822,3.576,4.854,2.169-.021,3.861-1.14,4.641-4.34-.141-.063.623-4.194-3.373-4.943Zm-.581.523a2.663,2.663,0,0,1,.468.027c2.518,1.16,2.129,2.137,2.107,4.229-.387,1.835-1.144,4.19-3.318,3.842,0,0-2.869-.122-2.237-4.413C325.8,186.472,326.749,185.131,328.206,185.088Z",
    transform: "translate(-248.244 -141.44)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1558",
    "data-name": "Raggruppa 1558",
    transform: "translate(48.065 32.73)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1557",
    "data-name": "Raggruppa 1557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1556",
    "data-name": "Raggruppa 1556",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3893",
    "data-name": "Tracciato 3893",
    d: "M206.085,150.218a8.166,8.166,0,0,0,1.844-.416c.263-.056.529-.1.79-.156a2.783,2.783,0,0,1,.58-.156,2.278,2.278,0,0,1,.843.208c.132.052.247.278.369.208s.007-.312,0-.468c-.009-.208-.181-.458-.053-.624s.4-.037.58-.1c.229-.084.543-.14.633-.364.067-.168.158-.52-.158-.52a2.9,2.9,0,0,1-1.107-.1.79.79,0,0,1-.474-.416c-.121-.394.414-.8.316-1.2-.105-.429-.722-.581-.9-.988-.1-.24.021-.53-.053-.78a2.589,2.589,0,0,0-.316-.572c-.149-.248-.461-.44-.474-.728a1.425,1.425,0,0,1,.58-1.092c.211-.052.517-.211.474-.416-.067-.322-.615-.3-.949-.312-.128,0-.257.165-.369.1a.342.342,0,0,1-.105-.364c.066-.275.626-.345.58-.624-.029-.176-.294-.249-.474-.26a.877.877,0,0,0-.527.208,3.158,3.158,0,0,0-.58.676c-.093.118-.269.215-.264.364s.27.177.264.312c-.01.22-.339.293-.474.468-.086.111-.259.232-.211.364s.3.071.422.156a.672.672,0,0,1,.316.364c.032.161-.132.306-.158.468-.014.086-.046.186,0,.26.062.1.276.047.316.156.058.161-.34.355-.211.468.23.2.494-.387.79-.468.085-.023.2-.054.264,0,.126.1.088.309.105.468a4.192,4.192,0,0,1,0,.468,6.577,6.577,0,0,0,0,.728c.018.159.138.311.105.468a.986.986,0,0,1-.422.572,2.145,2.145,0,0,1-.58.156c-.143.046-.362.02-.422.156-.091.207.308.4.264.624a.748.748,0,0,1-.474.468c-.211.086-.551-.183-.685,0-.065.089.014.25.105.312.29.2.7-.088,1.054-.052.271.028.624-.005.79.208.086.11.023.279,0,.416-.018.108-.02.242-.105.312-.367.3-.991,0-1.423.208-.325.154-.875.382-.79.728C205.746,150.236,205.958,150.214,206.085,150.218Z",
    transform: "translate(-205.708 -140.077)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3894",
    "data-name": "Tracciato 3894",
    d: "M206.085,150.218a8.166,8.166,0,0,0,1.844-.416c.263-.056.529-.1.79-.156a2.783,2.783,0,0,1,.58-.156,2.278,2.278,0,0,1,.843.208c.132.052.247.278.369.208s.007-.312,0-.468c-.009-.208-.181-.458-.053-.624s.4-.037.58-.1c.229-.084.543-.14.633-.364.067-.168.158-.52-.158-.52a2.9,2.9,0,0,1-1.107-.1.79.79,0,0,1-.474-.416c-.121-.394.414-.8.316-1.2-.105-.429-.722-.581-.9-.988-.1-.24.021-.53-.053-.78a2.589,2.589,0,0,0-.316-.572c-.149-.248-.461-.44-.474-.728a1.425,1.425,0,0,1,.58-1.092c.211-.052.517-.211.474-.416-.067-.322-.615-.3-.949-.312-.128,0-.257.165-.369.1a.342.342,0,0,1-.105-.364c.066-.275.626-.345.58-.624-.029-.176-.294-.249-.474-.26a.877.877,0,0,0-.527.208,3.158,3.158,0,0,0-.58.676c-.093.118-.269.215-.264.364s.27.177.264.312c-.01.22-.339.293-.474.468-.086.111-.259.232-.211.364s.3.071.422.156a.672.672,0,0,1,.316.364c.032.161-.132.306-.158.468-.014.086-.046.186,0,.26.062.1.276.047.316.156.058.161-.34.355-.211.468.23.2.494-.387.79-.468.085-.023.2-.054.264,0,.126.1.088.309.105.468a4.192,4.192,0,0,1,0,.468,6.577,6.577,0,0,0,0,.728c.018.159.138.311.105.468a.986.986,0,0,1-.422.572,2.145,2.145,0,0,1-.58.156c-.143.046-.362.02-.422.156-.091.207.308.4.264.624a.748.748,0,0,1-.474.468c-.211.086-.551-.183-.685,0-.065.089.014.25.105.312.29.2.7-.088,1.054-.052.271.028.624-.005.79.208.086.11.023.279,0,.416-.018.108-.02.242-.105.312-.367.3-.991,0-1.423.208-.325.154-.875.382-.79.728C205.746,150.236,205.958,150.214,206.085,150.218Z",
    transform: "translate(-157.643 -107.347)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1561",
    "data-name": "Raggruppa 1561",
    transform: "translate(40.138 17.003)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1560",
    "data-name": "Raggruppa 1560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1559",
    "data-name": "Raggruppa 1559",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3895",
    "data-name": "Tracciato 3895",
    d: "M200.721,72.769a2.227,2.227,0,0,0-.371.075,2.017,2.017,0,0,0-.666.353l.048.009-.655.569.115.846-.763-.428-.341.157c-.254.194-.508.388-.768.573a9.414,9.414,0,0,0-.975.676,12.753,12.753,0,0,0-1.819,2.236,4.167,4.167,0,0,0-.685,1.222c-.059.227.11.495,0,.7-.1.187-.476.159-.526.364-.035.143.21.259.21.389s.106.442.106.546-.329.04-.422.157a.3.3,0,0,0-.025.207c.01.126.181.264.1.364-.132.172-.465-.1-.657,0-.357.193-.385.718-.659,1.015a10.123,10.123,0,0,1-1.185.91c-.581.465-1.447.741-1.713,1.431-.066.172.177.39.078.546-.059.093-.243.02-.316.1-.164.186-.109.482-.131.728-.019.208-.15.478,0,.626s.519-.168.657,0c.051.062-.029.157-.051.234a1.43,1.43,0,0,1-.134.389.629.629,0,0,1-.131.13c-.066.057-.193.072-.21.157s.075.2.157.259.258-.013.318.077c.112.169-.114.4-.106.6s-.025.5.157.6c.247.139.582-.08.818-.234a1.272,1.272,0,0,0,.237-.287,3.69,3.69,0,0,1,.263-.312c.216-.206.517-.32.71-.546.167-.2.11-.688.369-.676.181.008.15.326.212.494a2.1,2.1,0,0,0,.131.416c.1.15.294.217.394.364a6.246,6.246,0,0,1,.528,1.351c.089.234.169.471.263.7.124.307.344.728.4.91s.278.3.341.494a2.516,2.516,0,0,1,.028.755c0,.1.029.185.1.207.118.035.243-.086.318-.182.161-.206.089-.522.21-.753a1.171,1.171,0,0,1,.237-.287c.144-.138.361-.2.475-.364a1.152,1.152,0,0,0,.157-.493,6.407,6.407,0,0,0,0-1.222c-.009-.235-.149-.488-.053-.7.063-.141.25-.186.369-.287s.243-.228.369-.336c.094-.081.2-.145.29-.234a1.338,1.338,0,0,0,.343-.469c.041-.123.086-.291,0-.389-.04-.047-.148.022-.184-.027s.018-.1.025-.155a.979.979,0,0,0,.025-.209c0-.063,0-.14-.051-.182-.14-.121-.4.024-.553-.077a.915.915,0,0,1-.291-.469,1.211,1.211,0,0,1-.078-.441,4.828,4.828,0,0,1,.1-.521,4.763,4.763,0,0,1,.028-.6,5.7,5.7,0,0,1,.263-.546c.047-.127.055-.266.106-.391a2.809,2.809,0,0,1,.263-.469c.119-.181.274-.338.394-.518a2.045,2.045,0,0,0,.212-.364c.057-.141.042-.3.106-.441a1.492,1.492,0,0,1,.21-.287c.109-.135.29-.227.343-.391a.4.4,0,0,0-.028-.312c-.021-.038-.082-.041-.106-.077a.589.589,0,0,1-.078-.389.844.844,0,0,1,.159-.314c.123-.194.318-.341.422-.546.057-.113.052-.249.1-.364.033-.074.1-.133.132-.207.093-.19.045-.467.212-.6.125-.1.319-.02.475-.052.087-.018.169-.1.254-.077.265.083.359.421.509.65a2.419,2.419,0,0,1,.422.78,1.466,1.466,0,0,1-.053.623,7.658,7.658,0,0,1-.528,1.351,5.546,5.546,0,0,1-.473.937c-.191.272-.545.427-.685.728a2.431,2.431,0,0,0-.159,1.4,2.927,2.927,0,0,0,.9,1.872,1.32,1.32,0,0,0,1.107.207c.346-.1.491-.528.789-.728a3.643,3.643,0,0,1,1.213-.571,1.977,1.977,0,0,1,.685,0,2.211,2.211,0,0,1,1.16.311.818.818,0,0,1,.212.466.747.747,0,0,1,0,.521c-.264.451-.874.607-1.372.78a2.886,2.886,0,0,1-.685.1c-.525.048-1.264-.365-1.582.05-.087.114.04.289.106.416.125.242.434.37.528.625.084.228-.053.468,0,.728s.3.189.422.311c.248.245.789.521.632.83-.071.14-.321.036-.475,0-.191-.044-.338-.2-.526-.259a2.979,2.979,0,0,0-.9-.1c-.338.007-.775-.091-1,.157s-.081.659-.053.987a2.935,2.935,0,0,0,.263,1.144c.181.336.689.466.791.833a.705.705,0,0,1-.106.468,2.606,2.606,0,0,1-.632.778,1.636,1.636,0,0,1-.738.469c-.39.068-.769-.193-1.16-.259a7.621,7.621,0,0,0-1.738-.209,19.109,19.109,0,0,0-2.107.521c-.211,0-.9.259-1.107.259s-.471.248-.687.157c-.413-.175-.526-.73-.685-1.144a2.517,2.517,0,0,1-.21-1.092,4.439,4.439,0,0,1,.316-.833,2.287,2.287,0,0,0,.21-.935.875.875,0,0,0-.369-.676.762.762,0,0,0-.738.1,1.478,1.478,0,0,0-.473,1.042,3.3,3.3,0,0,0,.21.935,10.225,10.225,0,0,0,.212,1.249c.158.479.816.865.685,1.351-.049.181-.345.175-.475.312-.193.2-.182.579-.422.728-.209.13-.491.044-.738.052a1.816,1.816,0,0,1-.475,0c-.305-.071-.637-.651-.841-.416s.574.434.526.728c-.038.232-.386.278-.579.416a10.8,10.8,0,0,1-1.16.833,6.576,6.576,0,0,1-1,.391,22.137,22.137,0,0,1,2.854.082l-.014.794.007,1.09c-.165.1-.33.183-.5.041l-.1-.96-.187-.441-.671-.036h-1.081l-.969.148-.558,3.308.261.075h.558l.971-.111.334-.146.261-.332.337-.551h.147l.187.33-.484,1.03.074,1.4-.261.257-.261-.257v-.994l-.15-.146h-1.787l-.373.146-.411,2.355-.147.846.3.366.3.148H186.4l1.042-.148.484-.221a1.568,1.568,0,0,0,.484-.33c.18-.26-.027-.724.224-.919a.214.214,0,0,1,.224,0,.492.492,0,0,1,.187.366,1.744,1.744,0,0,1-.15.626c-.056.21-.185.626-.185.626l-.671.441-1.008.073-1.453-.073h-1.268s-.868-.015-1.3-.036c-.361-.018-1.007.273-1.081-.075-.055-.257.479-.232.708-.366a1.568,1.568,0,0,0,.337-.221,1.148,1.148,0,0,0,.261-.4c.807-2.174.962-6.8.968-6.988a.135.135,0,0,1-.028.014c-.3.117-.8.267-1.084.418-.356.189-.63.517-1,.676a.894.894,0,0,1-.475.1c-.3-.049-.493-.388-.789-.469a1.461,1.461,0,0,0-.581,0,.728.728,0,0,0-.369.1.807.807,0,0,0-.316.623c.008.124.126.218.21.311a5.555,5.555,0,0,0,.687.573,6.876,6.876,0,0,1,.948.728,1.439,1.439,0,0,1,.21.364,3.9,3.9,0,0,1,.369,1.092,5.21,5.21,0,0,1-.051.676,2.78,2.78,0,0,1-.106.833,3.54,3.54,0,0,1-.632,1.04c-.242.3-.474.673-.844.78a1.078,1.078,0,0,1-.581-.1c-.293-.089-.559-.247-.842-.364-.349-.144-.7-.3-1.054-.416-.242-.081-.491-.141-.738-.207a8.991,8.991,0,0,0-1.425-.364,4.314,4.314,0,0,0-.948.052c-.178.022-.449-.057-.528.1-.121.243.361.457.369.728a1.193,1.193,0,0,1-.316.728c-.163.2-.5.244-.632.468-.071.121-.023.28-.053.416a2.345,2.345,0,0,1-.263.833,1.331,1.331,0,0,1-.316.259c-.207.161-.488.252-.634.469a3.324,3.324,0,0,0-.316,1.247c-.024.12-.034.243-.053.364-.049.313-.116.623-.157.937-.025.189-.136.4-.053.571.246.507,1.317.727,1.423.935a2.62,2.62,0,0,0,.791.728,1.772,1.772,0,0,0,.528.209,5.934,5.934,0,0,0,1.107.1c.474.022.948-.006,1.423,0a6.683,6.683,0,0,0,1.9.05c.3-.086.511-.37.789-.519.235-.125.51-.173.738-.311.255-.156.424-.521.687-.573s.049-.415.051-.623a3.851,3.851,0,0,1-.051-.833,2.372,2.372,0,0,1,.42-.728,1.986,1.986,0,0,1,.528-.676c.183-.108.368,0,.632-.1s.55-.367.844-.518a7.824,7.824,0,0,1,.738-.312c.191-.075.467-.039.579-.209.134-.2-.068-.485-.051-.728s-.031-.563.157-.728c.277-.243.736-.1,1.107-.1a7.959,7.959,0,0,0,.844.05,3.391,3.391,0,0,0,1.476-.466c.207-.139.3-.4.475-.573.276-.283.508-.687.895-.78a.872.872,0,0,1,.844.209c.183.232-.114.611,0,.883.057.136.21.209.316.314l.316.311c.158.156.33.3.475.466s.277.386.422.573a2.836,2.836,0,0,0,.422.518c.183.147.45.166.632.314.222.181.295.506.525.676a2.969,2.969,0,0,0,.687.259,1.948,1.948,0,0,1,.369.157,2.669,2.669,0,0,1,.263.259,5.352,5.352,0,0,0,.579.469c.3.2.656.31.95.518.212.15.473.285.579.521a.894.894,0,0,1,0,.466c-.026.213-.111.415-.157.625-.041.189-.232.422-.106.571.067.08.211,0,.316,0,.263,0,.266-.15.369-.259a1.682,1.682,0,0,0,.475-.78.985.985,0,0,0-.106-.623c-.068-.131-.253-.179-.316-.312a.626.626,0,0,1-.053-.573.338.338,0,0,1,.316-.1c.126.017.2.167.316.209.316.113.738.309,1,.1a.316.316,0,0,0,.051-.364c-.2-.388-.759-.443-1.158-.626a4.5,4.5,0,0,1-.95-.364c-.267-.208-.3-.64-.579-.83-.373-.253-.924-.1-1.319-.314a2.152,2.152,0,0,1-.842-.83c-.169-.312-.033-.734-.212-1.04-.011-.019-.022-.037-.035-.054a3.619,3.619,0,0,1-1.058.014,3.237,3.237,0,0,1-1.423-.546,2.9,2.9,0,0,1-.673-1.051,27.28,27.28,0,0,1,.224-2.953l.514-3.339c.077-.324.023-.5-.145-.546L191,99.428l-.014-.182.173-.157,1.317.039,1.12-.011h.593l.079.155-.039.157s-.1.011-.171.011H193.8l-.408.08-.238.155-.039.091-.079.469-.738,4.889-.053.7.025.585.212.43.71.441.3.023a.745.745,0,0,1-.071-.086,1.375,1.375,0,0,1-.316-.833c.015-.217.221-.377.316-.573.139-.287.09-.722.369-.883.245-.141.576.013.844.1.194.066.342.227.528.312.253.114.575.086.791.259a1.128,1.128,0,0,1,.18.184l.147-.38.251-1.351.3-1.859.173-.91c.009-.443,0-.466.011-.714l.028-.455-.014-.286L197,99.583l-.185-.077h-.383l-.21-.066-.041-.182.014-.141.2-.027.8.014.936.014.461.011.014.221-.053.132a1.84,1.84,0,0,0-.436.011c-.274.069-.276.354-.394.546l-.383,1.652-.71,3.926-.256.6a5.977,5.977,0,0,0,.309.632,2.491,2.491,0,0,0,.369.571,3.994,3.994,0,0,0,.685.364c.473.286.924.608,1.37.935.361.265.909.412,1.054.833.07.2-.167.409-.157.623a3.113,3.113,0,0,0,.316.885c.085.226.164.455.263.676a4.517,4.517,0,0,0,.369.728c.237.346.791.729.844.937s-.138.242-.106.364c.062.237.432.293.528.519.081.192-.08.431,0,.623a1.139,1.139,0,0,0,.632.626,1.3,1.3,0,0,0,1-.1,1.036,1.036,0,0,0,.422-.521,1.4,1.4,0,0,0,.053-.466,1.851,1.851,0,0,0,0-.626c-.064-.217-.271-.367-.369-.571-.119-.247-.16-.525-.263-.78-.093-.231-.292-.429-.318-.675-.024-.23-.057-.585.159-.676.189-.079.324.331.528.312s.3-.3.473-.416a8.651,8.651,0,0,0,.844-.416c.115-.1.118-.321.263-.364s.286.095.422.157a2.68,2.68,0,0,0,.475.259,1.447,1.447,0,0,0,.948-.052c.2-.1.243-.384.422-.519.244-.184.653-.126.844-.364a.631.631,0,0,0,.106-.573c-.17-.475-.947-.529-1.16-.987a2.612,2.612,0,0,1,0-1.249,9.7,9.7,0,0,0-.018-1.172,5.951,5.951,0,0,1-.341-2.411,4.71,4.71,0,0,1,4.24-4.4c-.077-1.3-.26-2.591-.456-3.876a44.276,44.276,0,0,0-.895-4.627c-.168-.636-.411-1.251-.632-1.872-.353-.994-.683-2-1.107-2.964-.144-.329-.311-.647-.48-.965l-.676.312.184-.835-.606-.619.5-.05c-.282-.62-.535-1.255-.872-1.847-.223-.392-.461-.775-.71-1.151l.03.223-.763-.428-.793.366.182-.835-.6-.619.876-.089.035-.064-.044-.057a10.218,10.218,0,0,0-1.476-1.663c-.238-.2-.49-.457-.749-.719l.058.428-.763-.425-.8.366.185-.835-.6-.619.385-.039a.97.97,0,0,0-.4-.016.528.528,0,0,1,.47-.3c.354.027.157-.1.185-.182a.8.8,0,0,0-.081-.519c-.1-.262-.481-.422-.473-.7,0-.13.184-.193.238-.312.073-.162.215-.382.1-.521A.35.35,0,0,0,200.721,72.769Z",
    transform: "translate(-171.782 -72.767)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3896",
    "data-name": "Tracciato 3896",
    d: "M200.721,72.769a2.227,2.227,0,0,0-.371.075,2.017,2.017,0,0,0-.666.353l.048.009-.655.569.115.846-.763-.428-.341.157c-.254.194-.508.388-.768.573a9.414,9.414,0,0,0-.975.676,12.753,12.753,0,0,0-1.819,2.236,4.167,4.167,0,0,0-.685,1.222c-.059.227.11.495,0,.7-.1.187-.476.159-.526.364-.035.143.21.259.21.389s.106.442.106.546-.329.04-.422.157a.3.3,0,0,0-.025.207c.01.126.181.264.1.364-.132.172-.465-.1-.657,0-.357.193-.385.718-.659,1.015a10.123,10.123,0,0,1-1.185.91c-.581.465-1.447.741-1.713,1.431-.066.172.177.39.078.546-.059.093-.243.02-.316.1-.164.186-.109.482-.131.728-.019.208-.15.478,0,.626s.519-.168.657,0c.051.062-.029.157-.051.234a1.43,1.43,0,0,1-.134.389.629.629,0,0,1-.131.13c-.066.057-.193.072-.21.157s.075.2.157.259.258-.013.318.077c.112.169-.114.4-.106.6s-.025.5.157.6c.247.139.582-.08.818-.234a1.272,1.272,0,0,0,.237-.287,3.69,3.69,0,0,1,.263-.312c.216-.206.517-.32.71-.546.167-.2.11-.688.369-.676.181.008.15.326.212.494a2.1,2.1,0,0,0,.131.416c.1.15.294.217.394.364a6.246,6.246,0,0,1,.528,1.351c.089.234.169.471.263.7.124.307.344.728.4.91s.278.3.341.494a2.516,2.516,0,0,1,.028.755c0,.1.029.185.1.207.118.035.243-.086.318-.182.161-.206.089-.522.21-.753a1.171,1.171,0,0,1,.237-.287c.144-.138.361-.2.475-.364a1.152,1.152,0,0,0,.157-.493,6.407,6.407,0,0,0,0-1.222c-.009-.235-.149-.488-.053-.7.063-.141.25-.186.369-.287s.243-.228.369-.336c.094-.081.2-.145.29-.234a1.338,1.338,0,0,0,.343-.469c.041-.123.086-.291,0-.389-.04-.047-.148.022-.184-.027s.018-.1.025-.155a.979.979,0,0,0,.025-.209c0-.063,0-.14-.051-.182-.14-.121-.4.024-.553-.077a.915.915,0,0,1-.291-.469,1.211,1.211,0,0,1-.078-.441,4.828,4.828,0,0,1,.1-.521,4.763,4.763,0,0,1,.028-.6,5.7,5.7,0,0,1,.263-.546c.047-.127.055-.266.106-.391a2.809,2.809,0,0,1,.263-.469c.119-.181.274-.338.394-.518a2.045,2.045,0,0,0,.212-.364c.057-.141.042-.3.106-.441a1.492,1.492,0,0,1,.21-.287c.109-.135.29-.227.343-.391a.4.4,0,0,0-.028-.312c-.021-.038-.082-.041-.106-.077a.589.589,0,0,1-.078-.389.844.844,0,0,1,.159-.314c.123-.194.318-.341.422-.546.057-.113.052-.249.1-.364.033-.074.1-.133.132-.207.093-.19.045-.467.212-.6.125-.1.319-.02.475-.052.087-.018.169-.1.254-.077.265.083.359.421.509.65a2.419,2.419,0,0,1,.422.78,1.466,1.466,0,0,1-.053.623,7.658,7.658,0,0,1-.528,1.351,5.546,5.546,0,0,1-.473.937c-.191.272-.545.427-.685.728a2.431,2.431,0,0,0-.159,1.4,2.927,2.927,0,0,0,.9,1.872,1.32,1.32,0,0,0,1.107.207c.346-.1.491-.528.789-.728a3.643,3.643,0,0,1,1.213-.571,1.977,1.977,0,0,1,.685,0,2.211,2.211,0,0,1,1.16.311.818.818,0,0,1,.212.466.747.747,0,0,1,0,.521c-.264.451-.874.607-1.372.78a2.886,2.886,0,0,1-.685.1c-.525.048-1.264-.365-1.582.05-.087.114.04.289.106.416.125.242.434.37.528.625.084.228-.053.468,0,.728s.3.189.422.311c.248.245.789.521.632.83-.071.14-.321.036-.475,0-.191-.044-.338-.2-.526-.259a2.979,2.979,0,0,0-.9-.1c-.338.007-.775-.091-1,.157s-.081.659-.053.987a2.935,2.935,0,0,0,.263,1.144c.181.336.689.466.791.833a.705.705,0,0,1-.106.468,2.606,2.606,0,0,1-.632.778,1.636,1.636,0,0,1-.738.469c-.39.068-.769-.193-1.16-.259a7.621,7.621,0,0,0-1.738-.209,19.109,19.109,0,0,0-2.107.521c-.211,0-.9.259-1.107.259s-.471.248-.687.157c-.413-.175-.526-.73-.685-1.144a2.517,2.517,0,0,1-.21-1.092,4.439,4.439,0,0,1,.316-.833,2.287,2.287,0,0,0,.21-.935.875.875,0,0,0-.369-.676.762.762,0,0,0-.738.1,1.478,1.478,0,0,0-.473,1.042,3.3,3.3,0,0,0,.21.935,10.225,10.225,0,0,0,.212,1.249c.158.479.816.865.685,1.351-.049.181-.345.175-.475.312-.193.2-.182.579-.422.728-.209.13-.491.044-.738.052a1.816,1.816,0,0,1-.475,0c-.305-.071-.637-.651-.841-.416s.574.434.526.728c-.038.232-.386.278-.579.416a10.8,10.8,0,0,1-1.16.833,6.576,6.576,0,0,1-1,.391,22.137,22.137,0,0,1,2.854.082l-.014.794.007,1.09c-.165.1-.33.183-.5.041l-.1-.96-.187-.441-.671-.036h-1.081l-.969.148-.558,3.308.261.075h.558l.971-.111.334-.146.261-.332.337-.551h.147l.187.33-.484,1.03.074,1.4-.261.257-.261-.257v-.994l-.15-.146h-1.787l-.373.146-.411,2.355-.147.846.3.366.3.148H186.4l1.042-.148.484-.221a1.568,1.568,0,0,0,.484-.33c.18-.26-.027-.724.224-.919a.214.214,0,0,1,.224,0,.492.492,0,0,1,.187.366,1.744,1.744,0,0,1-.15.626c-.056.21-.185.626-.185.626l-.671.441-1.008.073-1.453-.073h-1.268s-.868-.015-1.3-.036c-.361-.018-1.007.273-1.081-.075-.055-.257.479-.232.708-.366a1.568,1.568,0,0,0,.337-.221,1.148,1.148,0,0,0,.261-.4c.807-2.174.962-6.8.968-6.988a.135.135,0,0,1-.028.014c-.3.117-.8.267-1.084.418-.356.189-.63.517-1,.676a.894.894,0,0,1-.475.1c-.3-.049-.493-.388-.789-.469a1.461,1.461,0,0,0-.581,0,.728.728,0,0,0-.369.1.807.807,0,0,0-.316.623c.008.124.126.218.21.311a5.555,5.555,0,0,0,.687.573,6.876,6.876,0,0,1,.948.728,1.439,1.439,0,0,1,.21.364,3.9,3.9,0,0,1,.369,1.092,5.21,5.21,0,0,1-.051.676,2.78,2.78,0,0,1-.106.833,3.54,3.54,0,0,1-.632,1.04c-.242.3-.474.673-.844.78a1.078,1.078,0,0,1-.581-.1c-.293-.089-.559-.247-.842-.364-.349-.144-.7-.3-1.054-.416-.242-.081-.491-.141-.738-.207a8.991,8.991,0,0,0-1.425-.364,4.314,4.314,0,0,0-.948.052c-.178.022-.449-.057-.528.1-.121.243.361.457.369.728a1.193,1.193,0,0,1-.316.728c-.163.2-.5.244-.632.468-.071.121-.023.28-.053.416a2.345,2.345,0,0,1-.263.833,1.331,1.331,0,0,1-.316.259c-.207.161-.488.252-.634.469a3.324,3.324,0,0,0-.316,1.247c-.024.12-.034.243-.053.364-.049.313-.116.623-.157.937-.025.189-.136.4-.053.571.246.507,1.317.727,1.423.935a2.62,2.62,0,0,0,.791.728,1.772,1.772,0,0,0,.528.209,5.934,5.934,0,0,0,1.107.1c.474.022.948-.006,1.423,0a6.683,6.683,0,0,0,1.9.05c.3-.086.511-.37.789-.519.235-.125.51-.173.738-.311.255-.156.424-.521.687-.573s.049-.415.051-.623a3.851,3.851,0,0,1-.051-.833,2.372,2.372,0,0,1,.42-.728,1.986,1.986,0,0,1,.528-.676c.183-.108.368,0,.632-.1s.55-.367.844-.518a7.824,7.824,0,0,1,.738-.312c.191-.075.467-.039.579-.209.134-.2-.068-.485-.051-.728s-.031-.563.157-.728c.277-.243.736-.1,1.107-.1a7.959,7.959,0,0,0,.844.05,3.391,3.391,0,0,0,1.476-.466c.207-.139.3-.4.475-.573.276-.283.508-.687.895-.78a.872.872,0,0,1,.844.209c.183.232-.114.611,0,.883.057.136.21.209.316.314l.316.311c.158.156.33.3.475.466s.277.386.422.573a2.836,2.836,0,0,0,.422.518c.183.147.45.166.632.314.222.181.295.506.525.676a2.969,2.969,0,0,0,.687.259,1.948,1.948,0,0,1,.369.157,2.669,2.669,0,0,1,.263.259,5.352,5.352,0,0,0,.579.469c.3.2.656.31.95.518.212.15.473.285.579.521a.894.894,0,0,1,0,.466c-.026.213-.111.415-.157.625-.041.189-.232.422-.106.571.067.08.211,0,.316,0,.263,0,.266-.15.369-.259a1.682,1.682,0,0,0,.475-.78.985.985,0,0,0-.106-.623c-.068-.131-.253-.179-.316-.312a.626.626,0,0,1-.053-.573.338.338,0,0,1,.316-.1c.126.017.2.167.316.209.316.113.738.309,1,.1a.316.316,0,0,0,.051-.364c-.2-.388-.759-.443-1.158-.626a4.5,4.5,0,0,1-.95-.364c-.267-.208-.3-.64-.579-.83-.373-.253-.924-.1-1.319-.314a2.152,2.152,0,0,1-.842-.83c-.169-.312-.033-.734-.212-1.04-.011-.019-.022-.037-.035-.054a3.619,3.619,0,0,1-1.058.014,3.237,3.237,0,0,1-1.423-.546,2.9,2.9,0,0,1-.673-1.051,27.28,27.28,0,0,1,.224-2.953l.514-3.339c.077-.324.023-.5-.145-.546L191,99.428l-.014-.182.173-.157,1.317.039,1.12-.011h.593l.079.155-.039.157s-.1.011-.171.011H193.8l-.408.08-.238.155-.039.091-.079.469-.738,4.889-.053.7.025.585.212.43.71.441.3.023a.745.745,0,0,1-.071-.086,1.375,1.375,0,0,1-.316-.833c.015-.217.221-.377.316-.573.139-.287.09-.722.369-.883.245-.141.576.013.844.1.194.066.342.227.528.312.253.114.575.086.791.259a1.128,1.128,0,0,1,.18.184l.147-.38.251-1.351.3-1.859.173-.91c.009-.443,0-.466.011-.714l.028-.455-.014-.286L197,99.583l-.185-.077h-.383l-.21-.066-.041-.182.014-.141.2-.027.8.014.936.014.461.011.014.221-.053.132a1.84,1.84,0,0,0-.436.011c-.274.069-.276.354-.394.546l-.383,1.652-.71,3.926-.256.6a5.977,5.977,0,0,0,.309.632,2.491,2.491,0,0,0,.369.571,3.994,3.994,0,0,0,.685.364c.473.286.924.608,1.37.935.361.265.909.412,1.054.833.07.2-.167.409-.157.623a3.113,3.113,0,0,0,.316.885c.085.226.164.455.263.676a4.517,4.517,0,0,0,.369.728c.237.346.791.729.844.937s-.138.242-.106.364c.062.237.432.293.528.519.081.192-.08.431,0,.623a1.139,1.139,0,0,0,.632.626,1.3,1.3,0,0,0,1-.1,1.036,1.036,0,0,0,.422-.521,1.4,1.4,0,0,0,.053-.466,1.851,1.851,0,0,0,0-.626c-.064-.217-.271-.367-.369-.571-.119-.247-.16-.525-.263-.78-.093-.231-.292-.429-.318-.675-.024-.23-.057-.585.159-.676.189-.079.324.331.528.312s.3-.3.473-.416a8.651,8.651,0,0,0,.844-.416c.115-.1.118-.321.263-.364s.286.095.422.157a2.68,2.68,0,0,0,.475.259,1.447,1.447,0,0,0,.948-.052c.2-.1.243-.384.422-.519.244-.184.653-.126.844-.364a.631.631,0,0,0,.106-.573c-.17-.475-.947-.529-1.16-.987a2.612,2.612,0,0,1,0-1.249,9.7,9.7,0,0,0-.018-1.172,5.951,5.951,0,0,1-.341-2.411,4.71,4.71,0,0,1,4.24-4.4c-.077-1.3-.26-2.591-.456-3.876a44.276,44.276,0,0,0-.895-4.627c-.168-.636-.411-1.251-.632-1.872-.353-.994-.683-2-1.107-2.964-.144-.329-.311-.647-.48-.965l-.676.312.184-.835-.606-.619.5-.05c-.282-.62-.535-1.255-.872-1.847-.223-.392-.461-.775-.71-1.151l.03.223-.763-.428-.793.366.182-.835-.6-.619.876-.089.035-.064-.044-.057a10.218,10.218,0,0,0-1.476-1.663c-.238-.2-.49-.457-.749-.719l.058.428-.763-.425-.8.366.185-.835-.6-.619.385-.039a.97.97,0,0,0-.4-.016.528.528,0,0,1,.47-.3c.354.027.157-.1.185-.182a.8.8,0,0,0-.081-.519c-.1-.262-.481-.422-.473-.7,0-.13.184-.193.238-.312.073-.162.215-.382.1-.521A.35.35,0,0,0,200.721,72.769Z",
    transform: "translate(-131.644 -55.764)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1564",
    "data-name": "Raggruppa 1564",
    transform: "translate(77.252 43.648)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1563",
    "data-name": "Raggruppa 1563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1562",
    "data-name": "Raggruppa 1562",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3897",
    "data-name": "Tracciato 3897",
    d: "M333.328,186.8c-1.249.037-2.123,1.029-2.709,2.762a2.723,2.723,0,0,0,.334,0c.332-.036.673.015,1-.05.457-.091,1.044-.095,1.317-.468.442-.606.135-1.476.065-2.238Z",
    transform: "translate(-330.619 -186.804)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3898",
    "data-name": "Tracciato 3898",
    d: "M333.328,186.8c-1.249.037-2.123,1.029-2.709,2.762a2.723,2.723,0,0,0,.334,0c.332-.036.673.015,1-.05.457-.091,1.044-.095,1.317-.468.442-.606.135-1.476.065-2.238Z",
    transform: "translate(-253.367 -143.156)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1567",
    "data-name": "Raggruppa 1567",
    transform: "translate(51.896 43.859)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1566",
    "data-name": "Raggruppa 1566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1565",
    "data-name": "Raggruppa 1565",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3899",
    "data-name": "Tracciato 3899",
    d: "M222.764,187.705l-.6.034-.035.011c-.189.064.575-.047.632-.021Z",
    transform: "translate(-222.102 -187.705)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3900",
    "data-name": "Tracciato 3900",
    d: "M222.764,187.705l-.6.034-.035.011c-.189.064.575-.047.632-.021Z",
    transform: "translate(-170.206 -143.846)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1570",
    "data-name": "Raggruppa 1570",
    transform: "translate(44.557 36.287)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1569",
    "data-name": "Raggruppa 1569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1568",
    "data-name": "Raggruppa 1568",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3901",
    "data-name": "Tracciato 3901",
    d: "M190.786,158.709a.9.9,0,0,1,.211-1.04c.271-.253.751-.046,1.107-.156.15-.046.4-.055.422-.208.02-.121-.152-.205-.264-.26-.222-.11-.6.1-.738-.1a.779.779,0,0,1,.211-.936.651.651,0,0,1,.633,0c.124.057.13.279.263.312a.538.538,0,0,0,.527-.208c.138-.2-.174-.556,0-.728s.462-.048.685,0c.246.053.55.1.685.312a.835.835,0,0,1,0,.78c-.088.178-.386.186-.474.364-.131.265.01.59,0,.884-.009.26.118.581-.053.78-.2.231-.595.149-.9.208a6.2,6.2,0,0,1-1.318.208C191.446,158.909,190.973,158.99,190.786,158.709Z",
    transform: "translate(-190.695 -155.298)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3902",
    "data-name": "Tracciato 3902",
    d: "M190.786,158.709a.9.9,0,0,1,.211-1.04c.271-.253.751-.046,1.107-.156.15-.046.4-.055.422-.208.02-.121-.152-.205-.264-.26-.222-.11-.6.1-.738-.1a.779.779,0,0,1,.211-.936.651.651,0,0,1,.633,0c.124.057.13.279.263.312a.538.538,0,0,0,.527-.208c.138-.2-.174-.556,0-.728s.462-.048.685,0c.246.053.55.1.685.312a.835.835,0,0,1,0,.78c-.088.178-.386.186-.474.364-.131.265.01.59,0,.884-.009.26.118.581-.053.78-.2.231-.595.149-.9.208a6.2,6.2,0,0,1-1.318.208C191.446,158.909,190.973,158.99,190.786,158.709Z",
    transform: "translate(-146.137 -119.012)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1573",
    "data-name": "Raggruppa 1573",
    transform: "translate(52.184 56.543)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1572",
    "data-name": "Raggruppa 1572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1571",
    "data-name": "Raggruppa 1571",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3903",
    "data-name": "Tracciato 3903",
    d: "M223.808,241.992a.527.527,0,0,0-.316.156.391.391,0,0,0-.158.26.641.641,0,0,0,.264.416c.2.182.477.45.738.364.186-.061.188-.341.264-.52.043-.1.152-.212.105-.312C224.57,242.066,224.131,241.98,223.808,241.992Z",
    transform: "translate(-223.334 -241.99)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3904",
    "data-name": "Tracciato 3904",
    d: "M223.808,241.992a.527.527,0,0,0-.316.156.391.391,0,0,0-.158.26.641.641,0,0,0,.264.416c.2.182.477.45.738.364.186-.061.188-.341.264-.52.043-.1.152-.212.105-.312C224.57,242.066,224.131,241.98,223.808,241.992Z",
    transform: "translate(-171.15 -185.448)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1576",
    "data-name": "Raggruppa 1576",
    transform: "translate(58.205 53.09)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1575",
    "data-name": "Raggruppa 1575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1574",
    "data-name": "Raggruppa 1574",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3905",
    "data-name": "Tracciato 3905",
    d: "M249.989,228.847c.186-.166.122-.482.158-.728a1.4,1.4,0,0,0,.053-.676.288.288,0,0,0-.158-.156.72.72,0,0,0-.633,0c-.19.125-.226.4-.264.624a1.184,1.184,0,0,0,.053.78.5.5,0,0,0,.316.208A.549.549,0,0,0,249.989,228.847Z",
    transform: "translate(-249.106 -227.213)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3906",
    "data-name": "Tracciato 3906",
    d: "M249.989,228.847c.186-.166.122-.482.158-.728a1.4,1.4,0,0,0,.053-.676.288.288,0,0,0-.158-.156.72.72,0,0,0-.633,0c-.19.125-.226.4-.264.624a1.184,1.184,0,0,0,.053.78.5.5,0,0,0,.316.208A.549.549,0,0,0,249.989,228.847Z",
    transform: "translate(-190.901 -174.123)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1579",
    "data-name": "Raggruppa 1579",
    transform: "translate(58.136 55.55)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1578",
    "data-name": "Raggruppa 1578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1577",
    "data-name": "Raggruppa 1577",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3907",
    "data-name": "Tracciato 3907",
    d: "M250.131,238.217c.012.11-.174.155-.211.26-.064.18.024.383,0,.572-.018.142-.105.208-.105.416s.033.408-.105.52-.351,0-.527,0c-.123,0-.369.26-.369,0s-.008-.451,0-.676a3.585,3.585,0,0,1,.053-.728,1.351,1.351,0,0,1,.316-.728.456.456,0,0,1,.369-.1C249.8,237.8,250.1,237.972,250.131,238.217Z",
    transform: "translate(-248.81 -237.742)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3908",
    "data-name": "Tracciato 3908",
    d: "M250.131,238.217c.012.11-.174.155-.211.26-.064.18.024.383,0,.572-.018.142-.105.208-.105.416s.033.408-.105.52-.351,0-.527,0c-.123,0-.369.26-.369,0s-.008-.451,0-.676a3.585,3.585,0,0,1,.053-.728,1.351,1.351,0,0,1,.316-.728.456.456,0,0,1,.369-.1C249.8,237.8,250.1,237.972,250.131,238.217Z",
    transform: "translate(-190.674 -182.192)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1582",
    "data-name": "Raggruppa 1582",
    transform: "translate(62.012 59.099)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1581",
    "data-name": "Raggruppa 1581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1580",
    "data-name": "Raggruppa 1580",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3909",
    "data-name": "Tracciato 3909",
    d: "M268.321,253.082c.23.239-.011.661-.053.988-.022.175.024.4-.105.52-.167.158-.454.107-.685.1a3.629,3.629,0,0,1-.9-.156,1.941,1.941,0,0,1-.843-.312,1.177,1.177,0,0,1-.263-.572c-.042-.151-.12-.326-.053-.468a.342.342,0,0,1,.316-.208c.158,0-.263-.1.633,0a9.809,9.809,0,0,0,1,.1C267.688,253.1,268.1,252.856,268.321,253.082Z",
    transform: "translate(-265.396 -252.932)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3910",
    "data-name": "Tracciato 3910",
    d: "M268.321,253.082c.23.239-.011.661-.053.988-.022.175.024.4-.105.52-.167.158-.454.107-.685.1a3.629,3.629,0,0,1-.9-.156,1.941,1.941,0,0,1-.843-.312,1.177,1.177,0,0,1-.263-.572c-.042-.151-.12-.326-.053-.468a.342.342,0,0,1,.316-.208c.158,0-.263-.1.633,0a9.809,9.809,0,0,0,1,.1C267.688,253.1,268.1,252.856,268.321,253.082Z",
    transform: "translate(-203.384 -193.833)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1585",
    "data-name": "Raggruppa 1585",
    transform: "translate(74.783 56.938)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1584",
    "data-name": "Raggruppa 1584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1583",
    "data-name": "Raggruppa 1583",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3911",
    "data-name": "Tracciato 3911",
    d: "M323.015,244.069c-.008.356-.407.638-.738.78a2.3,2.3,0,0,1-.9,0c-.281,0-.633.26-.843,0s-.542-.3-.474-.52c.078-.258.525-.146.79-.208a8.819,8.819,0,0,0,1-.208c.264-.1.567-.295.843-.208A.439.439,0,0,1,323.015,244.069Z",
    transform: "translate(-320.055 -243.683)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3912",
    "data-name": "Tracciato 3912",
    d: "M323.015,244.069c-.008.356-.407.638-.738.78a2.3,2.3,0,0,1-.9,0c-.281,0-.633.26-.843,0s-.542-.3-.474-.52c.078-.258.525-.146.79-.208a8.819,8.819,0,0,0,1-.208c.264-.1.567-.295.843-.208A.439.439,0,0,1,323.015,244.069Z",
    transform: "translate(-245.272 -186.745)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1588",
    "data-name": "Raggruppa 1588",
    transform: "translate(65.368 34.265)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1587",
    "data-name": "Raggruppa 1587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1586",
    "data-name": "Raggruppa 1586",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3913",
    "data-name": "Tracciato 3913",
    d: "M279.858,146.982a1.212,1.212,0,0,0,0,.936c.027.1.056.251.158.26.186.016.288-.25.369-.416a1.883,1.883,0,0,0,.158-.884c0-.072.013-.178-.053-.208C280.276,146.573,279.982,146.784,279.858,146.982Z",
    transform: "translate(-279.762 -146.645)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3914",
    "data-name": "Tracciato 3914",
    d: "M279.858,146.982a1.212,1.212,0,0,0,0,.936c.027.1.056.251.158.26.186.016.288-.25.369-.416a1.883,1.883,0,0,0,.158-.884c0-.072.013-.178-.053-.208C280.276,146.573,279.982,146.784,279.858,146.982Z",
    transform: "translate(-214.393 -112.381)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1591",
    "data-name": "Raggruppa 1591",
    transform: "translate(61.218 37.249)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1590",
    "data-name": "Raggruppa 1590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1589",
    "data-name": "Raggruppa 1589",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3915",
    "data-name": "Tracciato 3915",
    d: "M262.029,159.578c-.072.076,0,.208,0,.312,0,.121-.068.263,0,.364a.381.381,0,0,0,.369.156c.158-.036.252-.217.316-.364s.176-.4.053-.52A.584.584,0,0,0,262.029,159.578Z",
    transform: "translate(-261.997 -159.417)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3916",
    "data-name": "Tracciato 3916",
    d: "M262.029,159.578c-.072.076,0,.208,0,.312,0,.121-.068.263,0,.364a.381.381,0,0,0,.369.156c.158-.036.252-.217.316-.364s.176-.4.053-.52A.584.584,0,0,0,262.029,159.578Z",
    transform: "translate(-200.78 -122.168)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1594",
    "data-name": "Raggruppa 1594",
    transform: "translate(60.037 37.406)",
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1593",
    "data-name": "Raggruppa 1593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1592",
    "data-name": "Raggruppa 1592",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3917",
    "data-name": "Tracciato 3917",
    d: "M257,160.351a.65.65,0,0,0,.105.676.278.278,0,0,0,.264.052.452.452,0,0,0,.263-.26.668.668,0,0,0,0-.468c-.037-.1-.1-.241-.211-.26A.448.448,0,0,0,257,160.351Z",
    transform: "translate(-256.945 -160.087)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3918",
    "data-name": "Tracciato 3918",
    d: "M257,160.351a.65.65,0,0,0,.105.676.278.278,0,0,0,.264.052.452.452,0,0,0,.263-.26.668.668,0,0,0,0-.468c-.037-.1-.1-.241-.211-.26A.448.448,0,0,0,257,160.351Z",
    transform: "translate(-196.908 -122.682)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1597",
    "data-name": "Raggruppa 1597",
    transform: "translate(65.568 16.505)",
    opacity: 0.325
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1596",
    "data-name": "Raggruppa 1596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1595",
    "data-name": "Raggruppa 1595",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3919",
    "data-name": "Tracciato 3919",
    d: "M282.595,72.99l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-280.617 -70.639)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3920",
    "data-name": "Tracciato 3920",
    d: "M282.595,72.99l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-215.049 -54.134)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1600",
    "data-name": "Raggruppa 1600",
    transform: "translate(68.961 18.858)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1599",
    "data-name": "Raggruppa 1599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1598",
    "data-name": "Raggruppa 1598",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3921",
    "data-name": "Tracciato 3921",
    d: "M297.115,83.06l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-295.137 -80.709)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3922",
    "data-name": "Tracciato 3922",
    d: "M297.115,83.06l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-226.176 -61.851)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1603",
    "data-name": "Raggruppa 1603",
    transform: "translate(72.239 22.534)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1602",
    "data-name": "Raggruppa 1602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1601",
    "data-name": "Raggruppa 1601",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3923",
    "data-name": "Tracciato 3923",
    d: "M311.145,98.79l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-309.167 -96.439)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3924",
    "data-name": "Tracciato 3924",
    d: "M311.145,98.79l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-236.928 -73.906)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1606",
    "data-name": "Raggruppa 1606",
    transform: "translate(75.272 26.875)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1605",
    "data-name": "Raggruppa 1605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1604",
    "data-name": "Raggruppa 1604",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3925",
    "data-name": "Tracciato 3925",
    d: "M324.125,117.37l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-322.147 -115.019)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3926",
    "data-name": "Tracciato 3926",
    d: "M324.125,117.37l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-246.875 -88.144)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1609",
    "data-name": "Raggruppa 1609",
    transform: "translate(50.303 43.134)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1608",
    "data-name": "Raggruppa 1608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1607",
    "data-name": "Raggruppa 1607",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3927",
    "data-name": "Tracciato 3927",
    d: "M222.52,186.568l-.006-1.09.014-.793c0-.132-5.9-.065-5.9-.065s-.2.174-.224.294a.43.43,0,0,0,.112.368.858.858,0,0,0,.41.11l.634-.037s-.146,4.8-.969,7.023a1.153,1.153,0,0,1-.261.4A1.573,1.573,0,0,1,216,193c-.229.135-.763.11-.708.368.075.349.72.056,1.081.074.434.021,1.3.037,1.3.037h1.267l1.453.074,1.006-.074.671-.441s.13-.415.186-.625a1.747,1.747,0,0,0,.149-.625.494.494,0,0,0-.186-.368.214.214,0,0,0-.224,0c-.251.2-.043.659-.224.919a1.578,1.578,0,0,1-.484.331l-.484.221-1.044.147h-1.453l-.3-.147-.3-.368.149-.846.41-2.353.373-.147h1.789l.149.147v.993l.261.257.261-.257-.075-1.4.484-1.029-.186-.331h-.149l-.336.552-.261.331-.336.147-.969.11h-.559l-.261-.073.559-3.309.969-.147h1.081l.671.037.186.441.1.958C222.19,186.749,222.355,186.664,222.52,186.568Z",
    transform: "translate(-215.287 -184.602)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3928",
    "data-name": "Tracciato 3928",
    d: "M222.52,186.568l-.006-1.09.014-.793c0-.132-5.9-.065-5.9-.065s-.2.174-.224.294a.43.43,0,0,0,.112.368.858.858,0,0,0,.41.11l.634-.037s-.146,4.8-.969,7.023a1.153,1.153,0,0,1-.261.4A1.573,1.573,0,0,1,216,193c-.229.135-.763.11-.708.368.075.349.72.056,1.081.074.434.021,1.3.037,1.3.037h1.267l1.453.074,1.006-.074.671-.441s.13-.415.186-.625a1.747,1.747,0,0,0,.149-.625.494.494,0,0,0-.186-.368.214.214,0,0,0-.224,0c-.251.2-.043.659-.224.919a1.578,1.578,0,0,1-.484.331l-.484.221-1.044.147h-1.453l-.3-.147-.3-.368.149-.846.41-2.353.373-.147h1.789l.149.147v.993l.261.257.261-.257-.075-1.4.484-1.029-.186-.331h-.149l-.336.552-.261.331-.336.147-.969.11h-.559l-.261-.073.559-3.309.969-.147h1.081l.671.037.186.441.1.958C222.19,186.749,222.355,186.664,222.52,186.568Z",
    transform: "translate(-164.984 -141.469)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1612",
    "data-name": "Raggruppa 1612",
    transform: "translate(59.338 43.324)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1611",
    "data-name": "Raggruppa 1611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1610",
    "data-name": "Raggruppa 1610",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3929",
    "data-name": "Tracciato 3929",
    d: "M254.122,185.415l1.318.039,1.12-.013h.593l.079.156-.039.156s-.105.013-.171.013h-.25l-.408.078-.237.156-.04.091-.079.468-.738,4.888-.053.7.026.585.211.429.711.442,1.015.078.83-.2.5-.429.422-.52.316-.806.25-1.352.3-1.859.171-.91c.009-.443,0-.467.013-.715l.026-.455-.013-.286-.026-.247-.184-.078h-.382l-.211-.065-.039-.182.013-.143.2-.026.8.013.935.013.461.013.013.221-.053.13a1.83,1.83,0,0,0-.435.013c-.275.069-.277.354-.4.546l-.382,1.651-.712,3.926-.593,1.4a2.314,2.314,0,0,1-1.291.767,4.088,4.088,0,0,1-1.581.117,3.235,3.235,0,0,1-1.423-.546,2.9,2.9,0,0,1-.672-1.053,27.308,27.308,0,0,1,.224-2.951l.514-3.341c.077-.323.024-.5-.145-.546l-.672-.039-.013-.182Z",
    transform: "translate(-253.951 -185.415)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3930",
    "data-name": "Tracciato 3930",
    d: "M254.122,185.415l1.318.039,1.12-.013h.593l.079.156-.039.156s-.105.013-.171.013h-.25l-.408.078-.237.156-.04.091-.079.468-.738,4.888-.053.7.026.585.211.429.711.442,1.015.078.83-.2.5-.429.422-.52.316-.806.25-1.352.3-1.859.171-.91c.009-.443,0-.467.013-.715l.026-.455-.013-.286-.026-.247-.184-.078h-.382l-.211-.065-.039-.182.013-.143.2-.026.8.013.935.013.461.013.013.221-.053.13a1.83,1.83,0,0,0-.435.013c-.275.069-.277.354-.4.546l-.382,1.651-.712,3.926-.593,1.4a2.314,2.314,0,0,1-1.291.767,4.088,4.088,0,0,1-1.581.117,3.235,3.235,0,0,1-1.423-.546,2.9,2.9,0,0,1-.672-1.053,27.308,27.308,0,0,1,.224-2.951l.514-3.341c.077-.323.024-.5-.145-.546l-.672-.039-.013-.182Z",
    transform: "translate(-194.613 -142.091)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1615",
    "data-name": "Raggruppa 1615",
    transform: "translate(67.017 43.305)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1614",
    "data-name": "Raggruppa 1614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1613",
    "data-name": "Raggruppa 1613",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3931",
    "data-name": "Tracciato 3931",
    d: "M288.157,185.339a.324.324,0,0,0-.15.4l.763.221-1.051,7.186c-.009.062.01.136-.028.187s-.064.028-.159.073a4.536,4.536,0,0,0-.7.391c-.057.044.041.221.113.234a16.614,16.614,0,0,0,3.039.064l.053-.3-.969-.2a.341.341,0,0,1-.224-.35c.278-1.2.508-3.546.763-3.583l.429.182c.231.123.283.212.334.2,0,0,.806,3.039,2.013,3.86a1.992,1.992,0,0,0,1.658.184c.113-.036.283-.123.263-.239-.024-.132-.253-.1-.378-.157l-.853-.357-1.768-3.567c2.44-1.224,2.527-3.264.65-4.284l-3.8-.15Zm1.828,8.761,0,.009c.005,0,.005-.007,0-.009m.719-8.3c.148,0,.3.017.4.021a1.348,1.348,0,0,1,.763.164,1.151,1.151,0,0,1,.429.755,2.531,2.531,0,0,1-.055.937,2.713,2.713,0,0,1-.355,1.1,1.712,1.712,0,0,1-.763.569,1.994,1.994,0,0,1-.839.093c-.191-.011-.576.058-.558-.13.127-1.359.521-3,.5-3.328C290.216,185.822,290.458,185.794,290.7,185.8Z",
    transform: "translate(-286.816 -185.337)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3932",
    "data-name": "Tracciato 3932",
    d: "M288.157,185.339a.324.324,0,0,0-.15.4l.763.221-1.051,7.186c-.009.062.01.136-.028.187s-.064.028-.159.073a4.536,4.536,0,0,0-.7.391c-.057.044.041.221.113.234a16.614,16.614,0,0,0,3.039.064l.053-.3-.969-.2a.341.341,0,0,1-.224-.35c.278-1.2.508-3.546.763-3.583l.429.182c.231.123.283.212.334.2,0,0,.806,3.039,2.013,3.86a1.992,1.992,0,0,0,1.658.184c.113-.036.283-.123.263-.239-.024-.132-.253-.1-.378-.157l-.853-.357-1.768-3.567c2.44-1.224,2.527-3.264.65-4.284l-3.8-.15Zm1.828,8.761,0,.009C289.988,194.1,289.988,194.1,289.985,194.1Zm.719-8.3c.148,0,.3.017.4.021a1.348,1.348,0,0,1,.763.164,1.151,1.151,0,0,1,.429.755,2.531,2.531,0,0,1-.055.937,2.713,2.713,0,0,1-.355,1.1,1.712,1.712,0,0,1-.763.569,1.994,1.994,0,0,1-.839.093c-.191-.011-.576.058-.558-.13.127-1.359.521-3,.5-3.328C290.216,185.822,290.458,185.794,290.7,185.8Z",
    transform: "translate(-219.8 -142.032)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1618",
    "data-name": "Raggruppa 1618",
    transform: "translate(59.25 12.096)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1617",
    "data-name": "Raggruppa 1617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1616",
    "data-name": "Raggruppa 1616",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3933",
    "data-name": "Tracciato 3933",
    d: "M255.555,54.12l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-253.577 -51.769)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3934",
    "data-name": "Tracciato 3934",
    d: "M255.555,54.12l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-194.327 -39.673)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1621",
    "data-name": "Raggruppa 1621",
    transform: "translate(62.44 14.225)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1620",
    "data-name": "Raggruppa 1620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1619",
    "data-name": "Raggruppa 1619",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3935",
    "data-name": "Tracciato 3935",
    d: "M269.2,63.23l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-267.227 -60.879)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3936",
    "data-name": "Tracciato 3936",
    d: "M269.2,63.23l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-204.787 -46.655)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1624",
    "data-name": "Raggruppa 1624",
    transform: "translate(75.113 59.218)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1623",
    "data-name": "Raggruppa 1623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1622",
    "data-name": "Raggruppa 1622",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3937",
    "data-name": "Tracciato 3937",
    d: "M323.445,255.79l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-321.467 -253.439)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3938",
    "data-name": "Tracciato 3938",
    d: "M323.445,255.79l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-246.354 -194.221)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1627",
    "data-name": "Raggruppa 1627",
    transform: "translate(71.898 63.118)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1626",
    "data-name": "Raggruppa 1626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1625",
    "data-name": "Raggruppa 1625",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3939",
    "data-name": "Tracciato 3939",
    d: "M309.685,272.48l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-307.707 -270.129)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3940",
    "data-name": "Tracciato 3940",
    d: "M309.685,272.48l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-235.809 -207.012)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1630",
    "data-name": "Raggruppa 1630",
    transform: "translate(68.947 66.653)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1629",
    "data-name": "Raggruppa 1629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1628",
    "data-name": "Raggruppa 1628",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3941",
    "data-name": "Tracciato 3941",
    d: "M297.055,287.61l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-295.077 -285.259)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3942",
    "data-name": "Tracciato 3942",
    d: "M297.055,287.61l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-226.13 -218.607)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1633",
    "data-name": "Raggruppa 1633",
    transform: "translate(65.627 69.408)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1632",
    "data-name": "Raggruppa 1632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1631",
    "data-name": "Raggruppa 1631",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3943",
    "data-name": "Tracciato 3943",
    d: "M282.845,299.4l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-280.867 -297.049)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3944",
    "data-name": "Tracciato 3944",
    d: "M282.845,299.4l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-215.24 -227.642)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1636",
    "data-name": "Raggruppa 1636",
    transform: "translate(62.465 71.903)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1635",
    "data-name": "Raggruppa 1635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1634",
    "data-name": "Raggruppa 1634",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3945",
    "data-name": "Tracciato 3945",
    d: "M269.315,310.08l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-267.337 -307.729)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3946",
    "data-name": "Tracciato 3946",
    d: "M269.315,310.08l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-204.872 -235.826)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1639",
    "data-name": "Raggruppa 1639",
    transform: "translate(59.25 73.777)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1638",
    "data-name": "Raggruppa 1638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1637",
    "data-name": "Raggruppa 1637",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3947",
    "data-name": "Tracciato 3947",
    d: "M255.555,318.1l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-253.577 -315.749)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3948",
    "data-name": "Tracciato 3948",
    d: "M255.555,318.1l-.762-.427-.795.366.184-.834-.6-.619.875-.089.421-.748.357.779.865.157-.654.57Z",
    transform: "translate(-194.327 -241.972)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1642",
    "data-name": "Raggruppa 1642",
    transform: "translate(60.383 8.747)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1641",
    "data-name": "Raggruppa 1641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1640",
    "data-name": "Raggruppa 1640",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3949",
    "data-name": "Tracciato 3949",
    d: "M258.611,37.435h.074a.187.187,0,0,1,.187.187v1.8a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-1.8a.187.187,0,0,1,.187-.187",
    transform: "translate(-258.424 -37.435)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1124",
    "data-name": "Rettangolo 1124",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V1.946a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,1.946V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(60.383 8.747)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1645",
    "data-name": "Raggruppa 1645",
    transform: "translate(63.474 10.53)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1644",
    "data-name": "Raggruppa 1644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1643",
    "data-name": "Raggruppa 1643",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3950",
    "data-name": "Tracciato 3950",
    d: "M271.841,45.065h.074a.187.187,0,0,1,.187.187v1.8a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-1.8a.187.187,0,0,1,.187-.187",
    transform: "translate(-271.654 -45.065)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1126",
    "data-name": "Rettangolo 1126",
    width: 0.447,
    height: 2.169,
    rx: 0.224,
    transform: "translate(63.474 10.53)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1648",
    "data-name": "Raggruppa 1648",
    transform: "translate(66.642 12.294)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1647",
    "data-name": "Raggruppa 1647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1646",
    "data-name": "Raggruppa 1646",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3951",
    "data-name": "Tracciato 3951",
    d: "M285.4,52.615h.074a.187.187,0,0,1,.187.187v1.8a.187.187,0,0,1-.187.187H285.4a.187.187,0,0,1-.187-.187V52.8a.187.187,0,0,1,.187-.187",
    transform: "translate(-285.214 -52.615)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1128",
    "data-name": "Rettangolo 1128",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V1.946a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,1.946V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(66.642 12.294)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1651",
    "data-name": "Raggruppa 1651",
    transform: "translate(69.958 14.869)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1650",
    "data-name": "Raggruppa 1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1649",
    "data-name": "Raggruppa 1649",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3952",
    "data-name": "Tracciato 3952",
    d: "M299.591,63.635h.074a.187.187,0,0,1,.187.187v1.8a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-1.8a.187.187,0,0,1,.187-.187",
    transform: "translate(-299.404 -63.635)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1130",
    "data-name": "Rettangolo 1130",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V1.946a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,1.946V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(69.958 14.869)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1654",
    "data-name": "Raggruppa 1654",
    transform: "translate(73.089 17.883)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1653",
    "data-name": "Raggruppa 1653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1652",
    "data-name": "Raggruppa 1652",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3953",
    "data-name": "Tracciato 3953",
    d: "M312.991,76.535h.074a.187.187,0,0,1,.187.187v2.62a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-2.62a.187.187,0,0,1,.187-.187",
    transform: "translate(-312.804 -76.535)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1132",
    "data-name": "Rettangolo 1132",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V2.77a.224.224,0,0,1-.224.224h0A.223.223,0,0,1,0,2.77V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(73.089 17.883)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1657",
    "data-name": "Raggruppa 1657",
    transform: "translate(76.37 21.596)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1656",
    "data-name": "Raggruppa 1656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1655",
    "data-name": "Raggruppa 1655",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3954",
    "data-name": "Tracciato 3954",
    d: "M327.031,92.425h.074a.187.187,0,0,1,.187.187v3.251a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187V92.612a.187.187,0,0,1,.187-.187",
    transform: "translate(-326.844 -92.425)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1134",
    "data-name": "Rettangolo 1134",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V3.4a.224.224,0,0,1-.224.224h0A.223.223,0,0,1,0,3.4V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(76.37 21.596)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1660",
    "data-name": "Raggruppa 1660",
    transform: "translate(60.196 15.64)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1659",
    "data-name": "Raggruppa 1659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1658",
    "data-name": "Raggruppa 1658",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3955",
    "data-name": "Tracciato 3955",
    d: "M257.811,66.935h.074a.187.187,0,0,1,.187.187V78.1a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187V67.122a.187.187,0,0,1,.187-.187",
    transform: "translate(-257.624 -66.935)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1136",
    "data-name": "Rettangolo 1136",
    d: "M.223,0h0A.224.224,0,0,1,.447.224v10.9a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,11.124V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(60.196 15.64)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1663",
    "data-name": "Raggruppa 1663",
    transform: "translate(63.549 17.294)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1662",
    "data-name": "Raggruppa 1662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1661",
    "data-name": "Raggruppa 1661",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3956",
    "data-name": "Tracciato 3956",
    d: "M272.161,74.015h.074a.187.187,0,0,1,.187.187v2.473a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187V74.2a.187.187,0,0,1,.187-.187",
    transform: "translate(-271.974 -74.015)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1138",
    "data-name": "Rettangolo 1138",
    d: "M.223,0h0A.224.224,0,0,1,.447.224v2.4a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,2.623V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(63.549 17.294)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.022
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1666",
    "data-name": "Raggruppa 1666",
    transform: "translate(60.233 76.968)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1665",
    "data-name": "Raggruppa 1665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1664",
    "data-name": "Raggruppa 1664",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3957",
    "data-name": "Tracciato 3957",
    d: "M257.971,329.4h.074a.187.187,0,0,1,.187.187v1.8a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-1.8a.187.187,0,0,1,.187-.187",
    transform: "translate(-257.784 -329.405)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1140",
    "data-name": "Rettangolo 1140",
    width: 0.447,
    height: 2.169,
    rx: 0.224,
    transform: "translate(60.233 76.968)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1669",
    "data-name": "Raggruppa 1669",
    transform: "translate(63.624 75.276)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1668",
    "data-name": "Raggruppa 1668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1667",
    "data-name": "Raggruppa 1667",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3958",
    "data-name": "Tracciato 3958",
    d: "M272.481,322.165h.074a.187.187,0,0,1,.187.187v1.8a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-1.8a.187.187,0,0,1,.187-.187",
    transform: "translate(-272.294 -322.165)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1142",
    "data-name": "Rettangolo 1142",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V1.946a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,1.946V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(63.624 75.276)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1672",
    "data-name": "Raggruppa 1672",
    transform: "translate(66.642 72.701)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1671",
    "data-name": "Raggruppa 1671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1670",
    "data-name": "Raggruppa 1670",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3959",
    "data-name": "Tracciato 3959",
    d: "M285.4,311.145h.074a.187.187,0,0,1,.187.187v2.591a.187.187,0,0,1-.187.187H285.4a.187.187,0,0,1-.187-.187v-2.591a.187.187,0,0,1,.187-.187",
    transform: "translate(-285.214 -311.145)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1144",
    "data-name": "Rettangolo 1144",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V2.74a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,2.74V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(66.642 72.701)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1675",
    "data-name": "Raggruppa 1675",
    transform: "translate(69.995 69.872)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1674",
    "data-name": "Raggruppa 1674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1673",
    "data-name": "Raggruppa 1673",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3960",
    "data-name": "Tracciato 3960",
    d: "M299.751,299.035h.074a.187.187,0,0,1,.187.187v2.853a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-2.853a.187.187,0,0,1,.187-.187",
    transform: "translate(-299.564 -299.035)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1146",
    "data-name": "Rettangolo 1146",
    width: 0.447,
    height: 3.226,
    rx: 0.224,
    transform: "translate(69.995 69.872)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1678",
    "data-name": "Raggruppa 1678",
    transform: "translate(72.939 66.451)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1677",
    "data-name": "Raggruppa 1677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1676",
    "data-name": "Raggruppa 1676",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3961",
    "data-name": "Tracciato 3961",
    d: "M312.351,284.395h.074a.187.187,0,0,1,.187.187v2.958a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-2.958a.187.187,0,0,1,.187-.187",
    transform: "translate(-312.164 -284.395)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1148",
    "data-name": "Rettangolo 1148",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V3.108a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,3.108V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(72.94 66.451)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1681",
    "data-name": "Raggruppa 1681",
    transform: "translate(76.22 62.444)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1680",
    "data-name": "Raggruppa 1680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1679",
    "data-name": "Raggruppa 1679",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3962",
    "data-name": "Tracciato 3962",
    d: "M326.391,267.245h.074a.187.187,0,0,1,.187.187v3.257a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-3.257a.187.187,0,0,1,.187-.187",
    transform: "translate(-326.204 -267.245)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1150",
    "data-name": "Rettangolo 1150",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V3.407a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,3.407V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(76.22 62.444)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1684",
    "data-name": "Raggruppa 1684",
    transform: "translate(60.308 60.532)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1683",
    "data-name": "Raggruppa 1683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1682",
    "data-name": "Raggruppa 1682",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3963",
    "data-name": "Tracciato 3963",
    d: "M258.291,259.065h.074a.17.17,0,0,1,.187.146v11.1a.17.17,0,0,1-.187.146h-.074a.17.17,0,0,1-.187-.146v-11.1a.17.17,0,0,1,.187-.146",
    transform: "translate(-258.104 -259.065)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3964",
    "data-name": "Tracciato 3964",
    d: "M258.291,259.065h.074a.17.17,0,0,1,.187.146v11.1a.17.17,0,0,1-.187.146h-.074a.17.17,0,0,1-.187-.146v-11.1A.17.17,0,0,1,258.291,259.065Z",
    transform: "translate(-197.796 -198.533)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1687",
    "data-name": "Raggruppa 1687",
    transform: "translate(63.586 63.769)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1686",
    "data-name": "Raggruppa 1686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1685",
    "data-name": "Raggruppa 1685",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3965",
    "data-name": "Tracciato 3965",
    d: "M272.321,272.915h.074a.187.187,0,0,1,.187.187v6.244a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187V273.1a.187.187,0,0,1,.187-.187",
    transform: "translate(-272.134 -272.915)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1153",
    "data-name": "Rettangolo 1153",
    d: "M.223,0h0A.224.224,0,0,1,.447.224v6.17a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,6.394V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(63.586 63.769)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1690",
    "data-name": "Raggruppa 1690",
    transform: "translate(66.493 60.717)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1689",
    "data-name": "Raggruppa 1689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1688",
    "data-name": "Raggruppa 1688",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3966",
    "data-name": "Tracciato 3966",
    d: "M284.761,259.855h.074a.187.187,0,0,1,.187.187v7.127a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-7.127a.187.187,0,0,1,.187-.187",
    transform: "translate(-284.574 -259.855)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1155",
    "data-name": "Rettangolo 1155",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V7.277A.223.223,0,0,1,.224,7.5h0A.223.223,0,0,1,0,7.277V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(66.493 60.717)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1693",
    "data-name": "Raggruppa 1693",
    transform: "translate(69.995 60.717)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1692",
    "data-name": "Raggruppa 1692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1691",
    "data-name": "Raggruppa 1691",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3967",
    "data-name": "Tracciato 3967",
    d: "M299.751,259.855h.074a.187.187,0,0,1,.187.187v4.3a.187.187,0,0,1-.187.187h-.074a.187.187,0,0,1-.187-.187v-4.3a.187.187,0,0,1,.187-.187",
    transform: "translate(-299.564 -259.855)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_1157",
    "data-name": "Rettangolo 1157",
    d: "M.223,0h0A.224.224,0,0,1,.447.224V4.45a.223.223,0,0,1-.223.223h0A.223.223,0,0,1,0,4.45V.223A.223.223,0,0,1,.223,0Z",
    transform: "translate(69.995 60.717)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1696",
    "data-name": "Raggruppa 1696",
    transform: "translate(10.688 17.922)",
    opacity: 0.314
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1695",
    "data-name": "Raggruppa 1695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1694",
    "data-name": "Raggruppa 1694",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3968",
    "data-name": "Tracciato 3968",
    d: "M45.744,116.03A151.77,151.77,0,0,0,65.025,98.976a15.063,15.063,0,0,0,5.017-9.933c.283-2.691-.8-6.48-4.734-6.786-5.563-.432-8.3,4.025-10.13,5.243a1.2,1.2,0,0,1-1.757-1.011c-.611.305,4.065-6.516,7.51-8.345a14.659,14.659,0,0,1,9.012-1.168c3.826,1.042,7.227,3.886,7.01,9.68-.25,6.674-2.946,9.248-6.008,12.851-4.072,4.792-14.854,13.018-14.854,13.018H68.943a5.54,5.54,0,0,0,3.171-1.168,10.145,10.145,0,0,0,2.17-3l1.669.668-3.839,9.346-25.368.167Z",
    transform: "translate(-45.744 -76.702)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3969",
    "data-name": "Tracciato 3969",
    d: "M45.744,116.03A151.77,151.77,0,0,0,65.025,98.976a15.063,15.063,0,0,0,5.017-9.933c.283-2.691-.8-6.48-4.734-6.786-5.563-.432-8.3,4.025-10.13,5.243a1.2,1.2,0,0,1-1.757-1.011c-.611.305,4.065-6.516,7.51-8.345a14.659,14.659,0,0,1,9.012-1.168c3.826,1.042,7.227,3.886,7.01,9.68-.25,6.674-2.946,9.248-6.008,12.851-4.072,4.792-14.854,13.018-14.854,13.018H68.943a5.54,5.54,0,0,0,3.171-1.168,10.145,10.145,0,0,0,2.17-3l1.669.668-3.839,9.346-25.368.167Z",
    transform: "translate(-35.056 -58.78)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDimenzioni);
export default __webpack_public_path__ + "static/media/move_dimenzioni.ebe8690228afe1eb26ea91594e232d49.svg";
export { ForwardRef as ReactComponent };